var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.messageStatus),expression:"messageStatus"}]},[_c('NewReleaseBody',{staticClass:"update-message"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }